export default __webpack_public_path__ + "static/media/minus-red.457b98f6.svg";